import React, { useEffect, useRef, useState } from 'react'
import { left_arrow, no_image } from '../../assets/imgs'
import ReactPlayer from 'react-player'
import CancelIcon from '@mui/icons-material/Cancel';
import { useLazyDocumentRequestQuery, useLazyPropertyImageDeleteQuery, usePropertiesRequestApproveMutation, usePropertyDocumentUpdateMutation } from '../../screens/redux/api/api';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router';

const DocumentVerificationProperty = ({ setTabs, data, value }) => {
    const [edit, setEdit] = useState(false);
    const [documentData, setDocumentData] = useState({
        aadhar_img: [],
        gst_img: [],
        gst_number: '',
        bs_certificate_img: [],
        account_no: '',
        ifsc_code: '',
        branch_code: '',
        branch_name: '',
        property_video: '',
        selfie_image: ''
    });
    const [imageToShow, setImageToShow] = useState(null);
    const id = data?.data?.id;
    const [documentViewApi] = useLazyDocumentRequestQuery();
    const [rejPopup, setRejPopup] = useState(false);
    const [reason, setReason] = useState('');

    const request = data?.request

    console.log('request', request)

    //RTK
    const [propertyApproveApi] = usePropertiesRequestApproveMutation();
    const [documentUpdateApi] = usePropertyDocumentUpdateMutation()
    const [propertyImageDelete] = useLazyPropertyImageDeleteQuery()

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();


    // Refs for file inputs
    const aadharInputRef = useRef(null);
    const gstInputRef = useRef(null);
    const bsCertInputRef = useRef(null);
    const selfieInputRef = useRef(null);
    const videoInputRef = useRef(null);

    const blobUrlToFile = async (blobUrl, filename) => {
        const res = await fetch(blobUrl);
        const blob = await res.blob();
        return new File([blob], filename, { type: blob.type });
    };


    const handleUpdate = async (id) => {
        if (!documentData.aadhar_img) {
            toast.error("Enter Aadhar Image")
            return
        }
        // if(!documentData.gst_number){
        //     toast.error("Enter Gst Number")
        //     return
        // }
        // if(!documentData.account_no){
        //     toast.error("Enter Account Number")
        //     return
        // }
        // if(!documentData.ifsc_code){
        //     toast.error("Enter IFSC Code")
        //     return
        // }
        // if(!documentData.branch_code){
        //     toast.error("Enter Gst Number")
        //     return
        // }
        // if(!documentData.branch_name){
        //     toast.error("Enter Branch Name")
        //     return
        // }
        setLoading(true);
        const formdata = new FormData();

        formdata.append('property_id', id);
        formdata.append('gst_number', documentData.gst_number);
        formdata.append('account_no', documentData.account_no);
        formdata.append('ifsc_code', documentData.ifsc_code);
        formdata.append('branch_code', documentData.branch_code);
        formdata.append('branch_name', documentData.branch_name);
        formdata.append('reject_reason', null);
        formdata.append('is_update', (documentData.gst_number == null && documentData.account_no == null) ? false : true)

        // Convert and append selfie image
        if (documentData.selfie_image?.startsWith('blob:')) {
            const file = await blobUrlToFile(documentData.selfie_image, 'selfie.jpg');
            formdata.append('selfie_image', file);
        }

        // Convert and append property video
        if (documentData.property_video?.startsWith('blob:')) {
            const file = await blobUrlToFile(documentData.property_video, 'property_video.mp4');
            formdata.append('property_video', file);
        }

        // Helper to handle array files
        const appendFilesFromBlobUrls = async (key, fileArray) => {
            for (let index = 0; index < fileArray.length; index++) {
                const item = fileArray[index];
                if (typeof item === 'string' && item.startsWith('blob:')) {
                    const file = await blobUrlToFile(item, `${key}_${index}.jpg`);
                    formdata.append(`${key}[${index}]`, file);
                }
            }
        };

        await appendFilesFromBlobUrls('aadhar_img', documentData.aadhar_img || []);
        await appendFilesFromBlobUrls('gst_img', documentData.gst_img || []);
        await appendFilesFromBlobUrls('bs_certificate_img', documentData.bs_certificate_img || []);

        documentUpdateApi(formdata)
            .unwrap()
            .then((res) => {
                if (res?.status === 'success') {
                    toast.success(res?.message);
                    setEdit(false);
                }
            })
            .catch((err) => {
                console.error(err);
                toast.error(err?.message);
            })
            .finally(() => {
                setLoading(false);
            });
    };




    const getDetails = (id) => {
        documentViewApi(id)
            .unwrap()
            .then((res) => {
                if (res?.data) {
                    setDocumentData({
                        aadhar_img: res.data.aadhar_img || [],
                        gst_img: res.data.gst_img || [],
                        gst_number: res.data.gst_number || '',
                        bs_certificate_img: res.data.bs_certificate_img || [],
                        account_no: res.data.account_no || '',
                        ifsc_code: res.data.ifsc_code || '',
                        branch_code: res.data.branch_code || '',
                        branch_name: res.data.branch_name || '',
                        property_video: res.data.property_video || '',
                        selfie_image: res.data.selfie_image || ''
                    });
                }
            })
            .catch((err) => {
                console.log("err", err);
                toast.error("Failed to load document data");
            });
    }



    // Fetch document data
    useEffect(() => {
        if (id) {
            getDetails(id)
        }
    }, [id]);

    // Handle file selection for images (multiple)
    const handleImageUpload = (e, field) => {
        const files = Array.from(e.target.files);

        if (field === 'selfie_image' && files.length > 1) {
            toast.error("You can upload only one selfie image");
            return;
        }

        if (files.length > 5 && field !== 'selfie_image') {
            toast.error("You can upload maximum 5 images");
            return;
        }

        const imageFiles = files.filter(file => file.type.startsWith('image/'));
        if (imageFiles.length !== files.length) {
            toast.error("Only image files are allowed");
            return;
        }

        const newImages = imageFiles.map(file => URL.createObjectURL(file));

        setDocumentData(prev => {
            // For selfie image (single), replace the existing one
            if (field === 'selfie_image') {
                return {
                    ...prev,
                    [field]: newImages[0] || ''
                };
            }

            // For other fields (multiple), append new images to existing
            const existingImages = prev[field] || [];
            return {
                ...prev,
                [field]: [...existingImages, ...newImages]
            };
        });
    };


    // Handle video upload
    const handleVideoUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (!file.type.startsWith('video/')) {
            toast.error("Only video files are allowed");
            return;
        }

        const videoUrl = URL.createObjectURL(file);
        setDocumentData(prev => ({
            ...prev,
            property_video: videoUrl
        }));
    };


    const handleImageDelete = (id) => {
        propertyImageDelete(id)
            .unwrap()
            .then((res) => {
                if (res?.status == 'success') {
                    toast.success(res?.message)
                }
            }).catch((err) => {
                toast.error(err?.message)
            })
    }

    // Remove an image
    const removeImage = (field, index) => {
        console.log('field', field)
        setDocumentData(prev => {
            if (field === 'selfie_image') {
                return { ...prev, [field]: '' };
            }
            const updatedImages = [...prev[field]];
            updatedImages.splice(index, 1);
            return { ...prev, [field]: updatedImages };
        });
    };

    // Handle field changes
    const handleFieldChange = (field, value) => {
        setDocumentData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    // Open image popup
    const openImagePopup = (imgUrl) => {
        setImageToShow(imgUrl);
    };

    const handleReject = (id) => {
        setLoading(true);
        let formdata = new FormData();
        formdata.append('approval_status', 0);
        formdata.append('verification_type', 1);
        formdata.append('status', 3);
        formdata.append('resaon', reason);
        propertyApproveApi({ id: id, payload: formdata })
            .unwrap()
            .then((res) => {
                if (res?.status == 'success') {
                    toast.success(res?.message);
                    navigate('/rejected-property');
                }
            }).catch((err) => {
                toast.error(err?.message);
            }).finally(() => {
                setLoading(false);
            });
    };

    const handleApprove = (id) => {
        setLoading(true);
        let formdata = new FormData();
        formdata.append('approval_status', 1);
        formdata.append('status', 3);
        formdata.append('detail_verification_status', 2);
        formdata.append('document_verification_status', 2);
        formdata.append('verification_type', 2);
        propertyApproveApi({ id: id, payload: formdata })
            .unwrap()
            .then((res) => {
                if (res?.status == 'success') {
                    toast.success(res?.message);
                    navigate('/approved-property');
                }
            }).catch((err) => {
                toast.error(err?.message);
            }).finally(() => {
                setLoading(false);
            });
    };
    console.log("value", value)

    return (

        <div className="mt-2">
            <div className="d-flex ac-js">
                <div className="d-flex ac-jb w-100">
                    <div className="d-flex ac-js pointer gap-2">
                        <img
                            src={left_arrow}
                            className="leftArrow mb-3 pointer"
                            onClick={() => { value == 2 ? setTabs(3) : setTabs(2) }}
                            alt="Back"
                        />
                        <p
                            className="f2 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 primary pointer"
                            onClick={() => { value == 2 ? setTabs(3) : setTabs(2) }}
                        >
                            Back
                        </p>
                    </div>
                    <div onClick={() => setEdit(!edit)}>
                        {!edit ? (<p className="f2 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 primary cust-btn recep-yes"
                            style={{ cursor: 'pointer' }}
                        >
                            Edit
                        </p>) : (<p className="f2 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 primary cust-btn recep-yes"
                            style={{ cursor: 'pointer' }}
                            onClick={() => getDetails(id)}
                        >
                            cancel
                        </p>)}
                    </div>
                </div>
            </div>

            {/* Aadhar Card Section */}
            <div className="d-flex gap-5 mb-4 align-items-center">
                <div className="col-md-5 mt-3">
                    <div className='d-flex ac-jb'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Business Registration Certificate *
                        </h4>
                        {edit && (
                            <>
                                <input
                                    type="file"
                                    accept="image/*"
                                    style={{ display: 'none' }}
                                    ref={bsCertInputRef}
                                    onChange={(e) => handleImageUpload(e, 'bs_certificate_img')}
                                    multiple
                                />
                                <button
                                    onClick={() => bsCertInputRef.current.click()}
                                    className="f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-11 fs-xxl-12 w-30 cust-btn recep-yes"
                                >
                                    Edit
                                </button>
                            </>
                        )}
                    </div>
                    <div className='d-flex ac-js gap-3 flex-wrap'>
                        {documentData.bs_certificate_img.length > 0 ? (
                            documentData.bs_certificate_img.map((img, index) => (
                                <div key={index} className="position-relative">
                                    <img
                                        src={img}
                                        className='small-imgs'
                                        alt={`Certificate ${index + 1}`}
                                        onClick={() => openImagePopup(img)}
                                        style={{ cursor: 'pointer' }}
                                    />
                                    {edit && (
                                        <CancelIcon
                                            className="red pointer"
                                            style={{
                                                position: "absolute",
                                                top: "-7px",
                                                right: "-7px",
                                                width: "15px",
                                            }}
                                            onClick={() => removeImage('bs_certificate_img', index)}
                                        />
                                    )}
                                </div>
                            ))
                        ) : (
                            <img src={no_image} className='small-imgs' alt="No Certificate" />
                        )}
                    </div>
                </div>

                <div className="col-md-5">
                    <div className='d-flex ac-jb'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Aadhar Card *
                        </h4>
                        {edit && (
                            <>
                                <input
                                    type="file"
                                    accept="image/*"
                                    style={{ display: 'none' }}
                                    ref={aadharInputRef}
                                    onChange={(e) => handleImageUpload(e, 'aadhar_img')}
                                    multiple
                                />
                                <button
                                    onClick={() => aadharInputRef.current.click()}
                                    className="f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-11 fs-xxl-12 w-30 cust-btn recep-yes"
                                >
                                    Edit
                                </button>
                            </>
                        )}
                    </div>
                    <div className='d-flex ac-js gap-3 flex-wrap'>
                        {documentData.aadhar_img.length > 0 ? (
                            documentData.aadhar_img.map((img, index) => (
                                <div key={index} className="position-relative">
                                    <img
                                        src={img}
                                        className='small-imgs'
                                        alt={`Aadhar ${index + 1}`}
                                        onClick={() => openImagePopup(img)}
                                        style={{ cursor: 'pointer' }}
                                    />
                                    {edit && (
                                        <CancelIcon
                                            className="red pointer"
                                            style={{
                                                position: "absolute",
                                                top: "-7px",
                                                right: "-7px",
                                                width: "15px",
                                            }}
                                            onClick={() => removeImage('aadhar_img', index)}
                                        />
                                    )}
                                </div>
                            ))
                        ) : (
                            <img src={no_image} className='small-imgs' alt="No Aadhar" />
                        )}
                    </div>
                </div>


            </div>

            {/* GST Number and Business Certificate Section */}
            <div className="d-flex gap-5 mb-4 align-items-center">
                {/* GST Section */}
                <div className="col-md-5 mt-3">
                    <div className='d-flex ac-jb'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            GST
                        </h4>
                        {edit && (
                            <>
                                <input
                                    type="file"
                                    accept="image/*"
                                    style={{ display: 'none' }}
                                    ref={gstInputRef}
                                    onChange={(e) => handleImageUpload(e, 'gst_img')}
                                    multiple
                                />
                                <button
                                    onClick={() => gstInputRef.current.click()}
                                    className="f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-11 fs-xxl-12 w-30 cust-btn recep-yes"
                                >
                                    Edit
                                </button>
                            </>
                        )}
                    </div>
                    <div className='d-flex ac-js gap-3 flex-wrap'>
                        {documentData.gst_img.length > 0 ? (
                            documentData.gst_img.map((img, index) => (
                                <div key={index} className="position-relative">
                                    <img
                                        src={img}
                                        className='small-imgs'
                                        alt={`GST ${index + 1}`}
                                        onClick={() => openImagePopup(img)}
                                        style={{ cursor: 'pointer' }}
                                    />
                                    {edit && (
                                        <CancelIcon
                                            className="red pointer"
                                            style={{
                                                position: "absolute",
                                                top: "-7px",
                                                right: "-7px",
                                                width: "15px",
                                            }}
                                            onClick={() => removeImage('gst_img', index)}
                                        />
                                    )}
                                </div>
                            ))
                        ) : (
                            <img src={no_image} className='small-imgs' alt="No GST" />
                        )}
                    </div>
                </div>
                <div className="col-md-5">
                    <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                        GST Number
                    </h4>
                    <input
                        readOnly={!edit}
                        type="text"
                        className="input-pop ps-2 w-100"
                        placeholder="GST Number "
                        value={documentData.gst_number}
                        onChange={(e) => handleFieldChange('gst_number', e.target.value)}
                    />
                </div>

            </div>

            <hr className="border-2 primary mt-3" />

            {/* Bank Details Section */}
            <h4 className="f2 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 my-3">
                Bank Details
            </h4>
            <div className="d-flex gap-5 mb-4 align-items-center">
                <div className="col-md-5">
                    <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                        Account Number
                    </h4>
                    <input
                        readOnly={!edit}
                        type="text"
                        className="input-pop ps-2 w-100"
                        placeholder="18181756678541"
                        value={documentData.account_no}
                        onChange={(e) => handleFieldChange('account_no', e.target.value)}
                    />
                </div>
                <div className="col-md-5">
                    <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                        IFSC Code
                    </h4>
                    <input
                        readOnly={!edit}
                        type="text"
                        className="input-pop ps-2 w-100"
                        placeholder="ICIC8541"
                        value={documentData.ifsc_code}
                        onChange={(e) => handleFieldChange('ifsc_code', e.target.value)}
                    />
                </div>
            </div>
            <div className="d-flex gap-5 mb-4 align-items-center">
                <div className="col-md-5">
                    <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                        Branch Code
                    </h4>
                    <input
                        readOnly={!edit}
                        type="text"
                        className="input-pop ps-2 w-100"
                        placeholder="Enter the Address"
                        value={documentData.branch_code}
                        onChange={(e) => handleFieldChange('branch_code', e.target.value)}
                    />
                </div>
                <div className="col-md-5">
                    <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                        Bank Name
                    </h4>
                    <input
                        readOnly={!edit}
                        type="text"
                        className="input-pop ps-2 w-100"
                        placeholder="ICICI"
                        value={documentData.branch_name}
                        onChange={(e) => handleFieldChange('branch_name', e.target.value)}
                    />
                </div>
            </div>

            <hr className="border-2 primary mt-3" />

            {/* Video Verification and Selfie Section */}
            <div className="d-flex flex-column gap-5 mb-4 ac-jc">
                <div className="col-md-5">
                    <div className='d-flex ac-jb'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Video Verification *
                        </h4>
                        {edit && (
                            <>
                                <input
                                    type="file"
                                    accept="video/*"
                                    style={{ display: 'none' }}
                                    ref={videoInputRef}
                                    onChange={handleVideoUpload}
                                />
                                <button
                                    onClick={() => videoInputRef.current.click()}
                                    className="f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-11 fs-xxl-12 w-30 cust-btn recep-yes"
                                >
                                    Edit
                                </button>
                            </>
                        )}
                    </div>
                    <div className='video-player'>
                        {documentData.property_video ? (
                            <ReactPlayer
                                width="100%"
                                height="50%"
                                controls={true}
                                url={documentData.property_video}
                            />
                        ) : (
                            <div className="d-flex ac-jc" style={{ height: '100%' }}>
                                <p>No video uploaded</p>
                            </div>
                        )}
                    </div>
                </div>
                <div className="col-md-5">
                    <div className='d-flex ac-jb'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Selfie Image *
                        </h4>
                        {edit && (
                            <>
                                <input
                                    type="file"
                                    accept="image/*"
                                    style={{ display: 'none' }}
                                    ref={selfieInputRef}
                                    onChange={(e) => handleImageUpload(e, 'selfie_image')}
                                />
                                <button
                                    onClick={() => selfieInputRef.current.click()}
                                    className="f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-11 fs-xxl-12 w-30 cust-btn recep-yes"
                                >
                                    {documentData.selfie_image ? 'ReUpload' : 'Upload'}
                                </button>
                            </>
                        )}
                    </div>
                    {documentData.selfie_image ? (
                        <div className="position-relative">
                            <img
                                src={documentData.selfie_image}
                                className='video-player'
                                alt="Selfie"
                                onClick={() => openImagePopup(documentData.selfie_image)}
                                style={{ cursor: 'pointer', height: '230px', width: '400px', objectFit: 'cover' }}
                            />
                            {edit && (
                                <CancelIcon
                                    className="red pointer"
                                    style={{
                                        position: "absolute",
                                        top: "-7px",
                                        right: "-7px",
                                        width: "15px",
                                    }}
                                    onClick={() => removeImage('selfie_image', 0)}
                                />
                            )}
                        </div>
                    ) : (
                        <img src={no_image} className='video-player' alt="No Selfie" style={{ height: '230px', width: '400px' }} />
                    )}
                </div>
            </div>

            {/* Image Preview Popup */}
            {imageToShow && (
                <div className="img-popup-design-new">
                    <div className="img-popup-new" style={{ maxWidth: '90%', maxHeight: '90%' }}>
                        <div className='d-flex ac-je'>
                            <button
                                className='cust-btn'
                                onClick={() => setImageToShow(null)}
                            >
                                <CancelIcon />
                            </button>
                        </div>
                        <div className="d-flex ac-jc" style={{ height: '100%' }}>
                            <img
                                src={imageToShow}
                                style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                                alt="Preview"
                            />
                        </div>
                    </div>
                </div>
            )}

            {rejPopup && (
                <div className="img-popup-design-new">
                    <div className="img-popup-new" style={{ height: '250px' }}>
                        <div className='d-flex ac-jb' >
                            <h4 className="f3 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 mt-2 sec">
                                Add Reason
                            </h4>
                            <button className='cust-btn' onClick={() => { setRejPopup(false); setReason(""); setLoading(false) }}>
                                <CancelIcon />
                            </button>
                        </div>
                        <h4 className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Reason
                        </h4>
                        <input type="text" value={reason} onChange={(e) => setReason(e.target.value)} className="input-pop ps-2 w-100" placeholder="Name" />

                        <div style={{ textAlign: 'center', marginTop: '20px' }}>
                            <button className="login-btn f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 mt-3"
                                onClick={() => handleReject(id)}
                            >
                                {loading ? (<div className="spinner-border spinner-border-sm"></div>) : "Submit"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Update Button */}
            {edit && (
                <div className="d-flex ac-je mt-5">
                    <button
                        className="login-btn f2 fs-sm-10 fs-md-8 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3"
                        onClick={() => handleUpdate(id)}
                        disabled={loading}
                    >
                        {loading ? (
                            <div className="spinner-border spinner-border-sm"></div>
                        ) : (
                            "Update"
                        )}
                    </button>
                </div>
            )}

        </div>
    )
};


export default DocumentVerificationProperty